import { Banner } from "@moe/oss/ui/banner";
import { CardPattern } from "@moe/oss/ui/card-pattern";
import { cn } from "@moe/oss/utils/utils";
import { useAppContext } from "@web/route-services/root/AppContext";
import { useMotionValue } from "motion/react";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  src?: string;
  className?: string;
  [key: string]: any;
}

export function AnnouncementBanner({ src, className, children, ...rest }: Props) {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);
  const { isDesktopScreen } = useAppContext();

  function onMouseMove({ currentTarget, clientX, clientY }: any) {
    const { left, top } = currentTarget.getBoundingClientRect();
    mouseX.set(clientX - left);
    mouseY.set(clientY - top);
  }

  return (
    <div className={cn("group/card relative flex", className)} onMouseMove={onMouseMove} {...rest}>
      {isDesktopScreen && <CardPattern className="rounded-[30px] md:rounded-[50px]" mouseX={mouseX} mouseY={mouseY} />}
      <Banner
        src={src ?? null}
        className="sm pointer-events-auto h-36 w-full rounded-[30px] opacity-40 transition duration-150 md:h-64 md:rounded-[50px]"
      />
      {children}
    </div>
  );
}
